/**
 * 名称近似司机弹窗
 */
import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, Space } from 'antd';
import styles from './SimilarDriversModal.module.scss';

interface SimilarDriversModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: (selectedDriver: any) => void;
  drivers: any[]; // 近似司机列表
  currentRecord: any; // 当前行数据
}

const SimilarDriversModal: React.FC<SimilarDriversModalProps> = ({
  visible,
  onCancel,
  onOk,
  drivers,
  currentRecord,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  // 弹窗关闭时重置选中状态
  useEffect(() => {
    if (!visible) {
      setSelectedRowKeys([]);
    }
  }, [visible]);

  // 选中司机后点击确定 - 调用更新逻辑
  const handleOk = () => {
    const selectedDriver = drivers.find((d) => selectedRowKeys.includes(d.id));
    // TODO: 调用更新逻辑
    onOk(selectedDriver);
  };

  // 目标司机不在表中，新建数据
  const handleCreateNew = () => {
    // TODO: 调用完全新增数据逻辑
    onOk(null);
  };

  // 表格列配置
  const columns = [
    {
      title: '司机姓名',
      dataIndex: 'name',
      key: 'name',
      width: 120,
    },
    {
      title: '手机号',
      dataIndex: 'mobile',
      key: 'mobile',
      width: 150,
    },
    {
      title: '车队名',
      dataIndex: 'companyName',
      key: 'companyName',
    },
  ];

  // 行选择配置
  const rowSelection = {
    type: 'radio' as const,
    selectedRowKeys,
    onChange: (selectedKeys: React.Key[]) => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  return (
    <Modal
      title="名称近似司机"
      open={visible}
      onCancel={onCancel}
      onOk={handleOk}
      width={800}
      className={styles.similarDriversModal}
      okButtonProps={{ disabled: selectedRowKeys.length === 0 }}
      okText="确定"
    >
      <div className={styles.modalContent}>
        <div className={styles.topButtonArea}>
          <Button type="primary" onClick={handleCreateNew}>
            目标司机不在表中，新建数据
          </Button>
        </div>
        <Table
          rowKey="id"
          dataSource={drivers}
          columns={columns}
          rowSelection={rowSelection}
          pagination={false}
          scroll={{ y: 400 }}
        />
      </div>
    </Modal>
  );
};

export default SimilarDriversModal;
